/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetId } from "../../commons/types/SheetId";
export const GenerateQueryConfig = core.serialization.object({
    sheetId: SheetId,
    command: core.serialization.string(),
    model: core.serialization.string().optional(),
    modelParams: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    queryType: core.serialization.string().optional(),
    templateVariables: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
});
